import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultFormEvents = {
    onSettingsChange: noop,
    onSubmit: noop
};

function useFormEvents(props) {
    const {
        formEvents: propsFormEvents
    } = props;

    const {
        events: formEvents
    } = useEvents(defaultFormEvents, propsFormEvents);

    const result = {
        formEvents
    };

    useDebugValue(result);

    return result;
}

export {useFormEvents};
